module.exports = __webpack_public_path__ + "img/footer-logo.e6a56dbc.png";